export enum PendingSwapsActionItem {
    PatientOutcomes,
    RecipientAboFile,
    RecipientDemoFile,
    DonorHlaFile,
    RecipientHlaFile,
    DonorCtReport,
    DonorMedChart,
    DonorAboVerif,
    ViewSerology,
    UploadSerology,
    ReuploadSerology,
    UploadFinalXm,
    ViewFinalXm,
    Evaluate,
    RequestSerologyKit,
    RequestScreeningXM,
    RequestFinalXM,
    EmergencyNotification,
    LogisticsPlan,
    FormsAndChecklists,
    RenalDataSheet,
    FinancialInfo,
    DonorCtStudy,
    CenterAboVerification,
    DonorAboMolecular,
}